
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.footer-subsection {
    display: block
}
.footer-subsection-hr {
    margin-top: 0px;
    margin-bottom: 1rem;
    height: 0.125rem;
    border-style: none;
    background-color: var(--tertiary-sky-blue)
}
.footer-subsection-title {
    margin-bottom: 1.25rem;
    font-size: var(--fs-xl);
    line-height: var(--lh-xl);
    font-weight: var(--fw-bold);
    color: var(--neutral-white)
}
.footer-subsection-slots ul {
    margin: 0px
}
.footer-subsection-slots ul {
    margin-bottom: 2rem
}
.footer-subsection-slots ul {
    list-style-type: none
}
.footer-subsection-slots ul {
    padding: 0px
}
.footer-subsection-slots ul {
    text-align: left
}
.footer-subsection-slots ul {
    color: var(--neutral-white)
}
.footer-subsection-slots ul li {
    margin-left: 0px;
    margin-right: 0px
}
.footer-subsection-slots ul li {
    margin-bottom: 0.875rem
}
.footer-subsection-slots a {
    color: var(--neutral-white)
}
.footer-subsection-slots a {
    text-decoration-line: none
}
.footer-subsection-slots a:hover {
    text-decoration-line: underline
}
:host([site='BH']) .footer-subsection-hr {
    display: none
}
:host([site='BH']) .footer-subsection-title {
    font-family: var(--bh-ff-display)
}
:host([site='BH']) .footer-subsection-title {
    font-size: var(--bh-fs-heading-04);
    line-height: var(--bh-lh-heading-04);
    letter-spacing: var(--bh-ls-heading-04)
}
:host([site='BH']) .footer-subsection-title {
    font-weight: var(--fw-normal)
}
:host([site='BH']) .footer-subsection-slots a {
    font-size: var(--bh-fs-body-01);
    line-height: var(--bh-lh-body-01);
    letter-spacing: var(--bh-ls-body-01)
}
`;